<div class="demo-page">
  <!-- Hero Section with integrated cards -->
  <section class="hero-with-cards">
    <div class="hero-cards-container">
      <div class="hero-section-wrapper">
        <app-hero-section></app-hero-section>
      </div>
      <div class="cards-section-wrapper">
        <app-user-cards></app-user-cards>
      </div>
    </div>
  </section>

  <!-- Academic Integrity Component -->
  <app-academic-integrity></app-academic-integrity>

  <!-- Learning Science Component -->
  <app-learning-science></app-learning-science>

  <!-- Demo Footer -->
  <footer class="demo-footer">
    <div class="ml-container">
      <div class="footer-content">
        <h4>Macmillan Learning Components</h4>
        <p>Authentic components built to match the official Macmillan Learning design system</p>
        <div class="tech-stack">
          <span class="tech-item">Angular {{ angularVersion }}</span>
          <span class="tech-item">Builder.io</span>
          <span class="tech-item">TypeScript</span>
        </div>
      </div>
    </div>
  </footer>
</div>
